export const getAmPm = (date: Date) => {
  const hours = date.getHours()
  const amPm = hours >= 12 ? '2' : '1' // 1 = AM, 2 = PM
  return amPm
}
